import MerchantService from "@/services/MerchantService.js";
import router from "@/router";
import { ls } from "@/utilities";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    subdomain: null,
    customerPortalToken: null,
    merchantSettings: {
      signup: {}
    },
    overlayLoading: false,
    isEstoreTopUp: false,
    isPointsView: false,
    maintenance: null,
    gtmData: {}
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_OVERLAY_LOADING(state, overlayLoading) {
      state.overlayLoading = overlayLoading;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    RESET_ERRORS(state) {
      state.errors = null;
    },
    SET_SUBDOMAIN(state, subdomain) {
      state.subdomain = subdomain;
    },
    SET_CUSTOMER_PORTAL_TOKEN(state, customerPortalToken) {
      state.customerPortalToken = customerPortalToken;
      // localStorage.setItem("customerPortalToken", customerPortalToken);
      ls.set("customerPortalToken", customerPortalToken);
    },
    SET_MERCHANT_SETTINGS(state, merchantSettings) {
      state.isEstoreTopUp = merchantSettings.topups
        .map(topup => topup.code)
        .includes("estore")
        ? merchantSettings.topups.find(topup => topup.code === "estore").enable
        : false;
      state.isPointsView = merchantSettings.enable_points_view;
      state.merchantSettings = merchantSettings;
      ls.set("isPointsView", merchantSettings.enable_points_view);
    },
    SET_MAINTENANCE(state, maintenance) {
      state.maintenance = maintenance
    },
    SET_GTM_DATA(state, data) {
      state.gtmData = data;
    }
  },
  getters: {
    isEstoreTopUp(state) {
      return state.isEstoreTopUp;
    },
    isPointsView(state) {
      return state.isPointsView;
    },
    getPointsView() {
      return ls.get('isPointsView')
    },
    isShowUploadReceipt(state) {
      return state.merchantSettings.enable_ocr_receipt || false;
    },
    isOcrCustomized(state) {
      return state.merchantSettings.custom_ocr_mechanics || false;
    },
    isGamificationEnabled(state) {
      if (!state.merchantSettings || !state.merchantSettings.topups) {
        return false;
      }
      const gamification = state.merchantSettings.topups.find(
        t => t.code === "gamification"
      );
      return gamification ? gamification.enable : false;
    }
  },
  actions: {
    async resetErrors({ commit }) {
      commit("RESET_ERRORS");
    },
    async fetchCustomerPortalToken({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        let request = {
          subdomain: state.subdomain
        };

        MerchantService.getCustomerPortalToken(
          request
        ).then(response => {
          commit("SET_CUSTOMER_PORTAL_TOKEN", response.token);
          commit("SET_LOADING", false);
          return resolve(response.token);
        })
          .catch(errors => {
            router.push({
              name: "404"
            });
            commit("SET_ERRORS", errors);
            commit("SET_LOADING", false);
            return reject(errors);
          });
      })
    },
    async fetchMerchantSettings({ commit, state }) {
      commit("SET_LOADING", true);
      try {
        let request = {
          "X-Merchant-Token": state.customerPortalToken
        };
        let merchantSettings = await MerchantService.getMerchantSettings(
          request
        );
        commit("SET_MERCHANT_SETTINGS", merchantSettings);
        // Start: Check for MEDPadala Customization
        const medPadalaCustomization = Object.keys(merchantSettings.customizations).includes("estore_wallets")
          ? merchantSettings.customizations.estore_wallets.find(wallet => wallet.type === "med-padala")
          : null;
        commit("medpadala/SET_MEDPADALA_CUSTOMIZATION", medPadalaCustomization, { root: true });
        // End: Check for MEDPadala Customization
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async fetchSubdomain({ commit, dispatch, rootGetters }, subdomain) {
      let storedSudomain = localStorage.getItem("subdomain");
      if (storedSudomain != null && subdomain != storedSudomain) {
        if (rootGetters["auth/loggedIn"]) {
          dispatch("auth/logout", null, { root: true });
        }

        if (Vue.$cookies.get("cart_uuid")) {
          Vue.$cookies.remove("cart_uuid")
        }
      }

      localStorage.setItem("subdomain", subdomain);
      commit("SET_SUBDOMAIN", subdomain);
    },
    async fetchMerchantMaintenance({ commit, state }) {
      commit("SET_LOADING", true);
      try {
        let request = {
          "X-Merchant-Token": state.customerPortalToken
        };
        const merchantMaintenance = await MerchantService.getMerchantMaintenance(
          request
        );

        const maintenance = merchantMaintenance.data.maintenance.find(m => m.status === "on_going")
        commit("SET_MAINTENANCE", maintenance);
        commit("SET_LOADING", false);
      } catch (errors) {
        commit("SET_ERRORS", errors);
        commit("SET_LOADING", false);
      }
    },
    async getGoogleTagCode({ commit, state }) {
      commit("SET_LOADING", true);
      commit("SET_GTM_DATA", {});
      const request = {
        "X-Merchant-Token": state.customerPortalToken
      };
      try {
        const { data } = await MerchantService.getGoogleTagCode(request);
        commit("SET_GTM_DATA", data);
      } catch (errors) {
        commit("SET_ERRORS", errors);
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async logRedirectRevamp({ state }) {
      const request = {
        "X-Merchant-Token": state.customerPortalToken
      };
      await MerchantService.logRedirectRevamp(request);
    }
  }
};